<template>
  <div class="w-full flex justify-between">
    <template v-if="data.is_fake">
      <div class="w-full py-2 px-3">
        <div
          class="cursor-pointer rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          @click="openOurPlansModal"
        >
          <div
            class="group w-full flex justify-center items-center font-medium text-gray-800"
          >
            <Icon name="LockOpen" class="w-6 mr-4" />

            <p
              class="text-sm font-semibold leading-normal tracking-wider group-focus:text-xl"
            >
              Unlock
            </p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import Icon from "@/components/UI/Icon";

export default {
  components: { Icon },
  props: {
    data: Object,
  },
  setup(props) {
    const store = useStore();

    const showAnalysis = ref(false);

    const user = computed(() => store.state.user);
    const role = computed(() => store.state.role);

    const analysisFormat = computed(() => {
      if (props.data.analysis) {
        return props.data.analysis.split("• ");
      }
      return "";
    });

    const toggleAnalysis = () => {
      showAnalysis.value = !showAnalysis.value;
    };

    const toggleFavoriteState = async (ad) => {
      if (["free"].includes(role.value)) {
        openOurPlansModal();
        return true;
      }

      if (ad.isFavorite) {
        await store.dispatch("REMOVE_FAVORITE_ADD", {
          user_id: user.value.id,
          advertisement_id: ad.id,
        });
      } else {
        await store.dispatch("ADD_FAVORITE_AD", {
          user_id: user.value.id,
          advertisement: ad,
        });
      }
    };

    const openOurPlansModal = () => {
      store.commit("SET_OURPLANS_ACTIVE", true);
    };

    return {
      showAnalysis,
      user,
      role,
      analysisFormat,
      toggleFavoriteState,
      toggleAnalysis,
      openOurPlansModal,
    };
  },
};
</script>

<style></style>
